import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../../api';

export default function CallTracking() {
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState('');
  const [calls, setCalls] = useState([]);
  const [days, setDays] = useState(30);

  useEffect(() => { api('/analytics/sites').then(r => r.ok ? r.json() : []).then(setSites).catch(() => {}); }, []);

  useEffect(() => {
    if (!selectedSite) { setCalls([]); return; }
    api(`/analytics/sites/${selectedSite}/calls?days=${days}`).then(r => r.ok ? r.json() : []).then(setCalls).catch(() => {});
  }, [selectedSite, days]);

  useEffect(() => {
    if (sites.length > 0 && !selectedSite) setSelectedSite(sites[0].id);
  }, [sites, selectedSite]);

  const formatDuration = (s) => {
    if (!s) return '—';
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m}:${sec.toString().padStart(2, '0')}`;
  };

  return (
    <Layout>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Call Tracking</h2>
        <div className="flex gap-2">
          <select value={selectedSite} onChange={e => setSelectedSite(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm">
            {sites.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
          <select value={days} onChange={e => setDays(Number(e.target.value))}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm">
            <option value={7}>Last 7 days</option>
            <option value={30}>Last 30 days</option>
            <option value={90}>Last 90 days</option>
          </select>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Caller</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Tracking #</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Duration</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {calls.map(call => (
              <tr key={call.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 font-medium text-gray-900">{call.callerNumber || '—'}</td>
                <td className="px-6 py-4 text-gray-600 hidden sm:table-cell">{call.trackingNumber || '—'}</td>
                <td className="px-6 py-4 text-gray-600 hidden sm:table-cell">{formatDuration(call.durationSeconds)}</td>
                <td className="px-6 py-4 hidden sm:table-cell">
                  <span className={`inline-flex px-2 py-1 rounded text-xs font-medium ${
                    call.status === 'completed' ? 'bg-green-50 text-green-700' :
                    call.status === 'no-answer' ? 'bg-yellow-50 text-yellow-700' :
                    'bg-gray-100 text-gray-600'
                  }`}>{call.status || '—'}</span>
                </td>
                <td className="px-6 py-4 text-gray-600">{call.createdAt ? new Date(call.createdAt).toLocaleString() : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {calls.length === 0 && <div className="text-center py-12 text-gray-500">{selectedSite ? 'No calls recorded yet.' : 'Select a site to view calls.'}</div>}
      </div>
    </Layout>
  );
}
